import axios from 'axios';
import ApiAuthenticationService from "../services/ApiAuthenticationService";
import {router} from "@/router";

//Cette fonction permet d'intercepter toutes les requetes AJAX et d'ajouter le "Bearer" si besoin
export function InitSecureRequestInterceptor(){
    axios.interceptors.request.use(function (config) {
        if(config.url.indexOf(process.env.VUE_APP_API_SECURE_URI) === 0){
            //On ajoute le bearer si il en exite un
            const token = ApiAuthenticationService.getAccessToken();
            if(token){
                config.headers.Authorization =  "Bearer "+token;
                return config;
            }
        }

        return config;
    });

    axios.interceptors.response.use(undefined, function (error) {
        if (error.response && error.response.status === 401 && !error.config._retry) {
            error.config._retry = true;

            return new Promise((resolve) => {
                ApiAuthenticationService.checkAccess((res) => {
                    if (res === true) {
                        axios.request(error.config)
                            .then(response => resolve(response))
                    } else {
                        ApiAuthenticationService.signOut();
                        router.push('/auth/login');
                    }
                }, true);
            });
        }

        return Promise.reject(error);
    });
}
